import React, { useEffect, useRef } from 'react';
import { Backdrop, Box, Typography } from '@mui/material';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import mafLoadingAnimation from '../assets/lottie/maf_loading.json';

interface LoadingIndicatorProps {
  open: boolean;
  message?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ open, message = 'Chargement...' }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    lottieRef.current?.setSpeed(1.5);
  }, [open]);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
      }}
      open={open}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Lottie
          lottieRef={lottieRef}
          animationData={mafLoadingAnimation}
          loop
          autoplay
          style={{ width: 200, height: 200 }}
        />
        {message && (
          <Typography
            variant="h6"
            sx={{
              color: '#fff',
              fontWeight: 500,
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
            }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
};

export default LoadingIndicator;
